import { gql } from "@apollo/client";
import { useIsValidProviderAndPatientQuery } from "../generated/graphql";

export const IS_VALID_PROVIDER_AND_PATIENT_QUERY = gql`
  query IsValidProviderAndPatient($providerShortId: ID!, $patientShortId: ID!) {
    isValidProviderAndPatient(
      providerShortId: $providerShortId
      patientShortId: $patientShortId
    )
  }
`;

export function useIsValidProviderAndPatient(
  providerShortId: string,
  patientShortId: string,
) {
  return useIsValidProviderAndPatientQuery({
    variables: { providerShortId, patientShortId },
    context: { skipAuth: true },
  });
}
